import { clsx } from 'clsx'
import { type FC } from 'react'

import { useGlobalConfigContext } from '../../../global-config'
import {
  IMAGE_PRODUCT_FALLBACK_SRC,
  NextImageWithFallback,
} from '../../../image'
import { TENANT } from '../../../tenant'

type LoginRegistrationSiqtLogoProps = {
  className?: string
}

export const LoginRegistrationSiqtLogo: FC<LoginRegistrationSiqtLogoProps> = ({
  className,
}) => {
  const { assetsPrefix, language, tenant } = useGlobalConfigContext()
  if (tenant !== TENANT.CH) {
    return null
  }

  const imageSrc = `${assetsPrefix}/logos/logo-siqt-${language}.png`

  return (
    <div className={clsx('mx-auto w-64', className)}>
      <NextImageWithFallback
        alt="siqt"
        className="size-full object-contain"
        fallbackSrc={IMAGE_PRODUCT_FALLBACK_SRC}
        height={12}
        src={imageSrc}
        width={12}
      />
    </div>
  )
}
